import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { QuantitySelector } from './QuantitySelector';
import clsx from 'clsx';

const PREFIX = 'QuantityField';

const classes = {
    image: `${PREFIX}image`,
    secondary: `${PREFIX}secondary`
};

const StyledBox = styled(Box, {
    shouldForwardProp: prop => prop !== 'productImage'
})<{ productImage: string }>(({ theme, productImage: image }) => ({
    [`& .${classes.image}`]: {
        height: '40px',
        width: '40px',
        backgroundImage: `url(${image})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        marginRight: theme.spacing(1),
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden'
    },

    [`& .${classes.secondary}`]: {
        opacity: 0.7
    }
}));

export interface QuantityFieldProps {
    label: React.ReactNode;
    description?: string;
    value: number;
    onChange: (value: number) => void;
    min?: number;
    image?: string;
    max?: number;
    disabledMax?: boolean;
    disabled?: boolean;
}

export const QuantityField: React.FC<React.PropsWithChildren<QuantityFieldProps>> = props => {
    const { label, value, onChange, description, disabledMax, image, disabled, min = 0, max = 999 } = props;

    return (
        <StyledBox
            productImage={image ?? ''}
            display="flex"
            width="100%"
            alignItems="center"
            justifyContent="space-between"
        >
            <Box display="flex" flexDirection="column" alignItems="flex-start">
                <Typography className={clsx({ [classes.secondary]: disabled })}>{label}</Typography>
                {description && (
                    <Typography variant="caption" className={classes.secondary}>
                        {description}
                    </Typography>
                )}
            </Box>
            <Box display="flex" alignItems="center">
                {!!image && <div className={classes.image} />}
                <QuantitySelector
                    disabledMax={disabledMax || disabled}
                    min={min}
                    max={max}
                    quantity={value}
                    onChange={onChange}
                />
            </Box>
        </StyledBox>
    );
};
